import type { AgentStatus } from '../lib/types'

/**
 * Zustand immer mit Text, nie nur über die Farbe (docs/design.md).
 */
export function StatusBadge({ state, label }: { state: 'ok' | 'warn' | 'crit' | 'info' | 'off'; label: string }) {
  return <span className={`badge badge-${state}`}>{label}</span>
}

export function AgentStatusBadge({ status, connected }: { status: AgentStatus; connected: boolean }) {
  if (status === 'revoked') return <StatusBadge state="crit" label="Gesperrt" />
  if (connected) return <StatusBadge state="ok" label="Online" />
  if (status === 'offline') return <StatusBadge state="crit" label="Offline" />
  return <StatusBadge state="off" label="Unbekannt" />
}

export function DeviceStateBadge({ state }: { state?: string }) {
  switch (state) {
    case 'ok':
      return <StatusBadge state="ok" label="Erreichbar" />
    case 'warn':
      return <StatusBadge state="warn" label="Warnung" />
    case 'crit':
      return <StatusBadge state="crit" label="Nicht erreichbar" />
    default:
      return <StatusBadge state="off" label="Unbekannt" />
  }
}
